import { RoiInputs, RoiResult } from '@/types/roi-calculator.types';

export function money(value: number): string {
	return `$${Math.round(value).toLocaleString('en-US')}`;
}

export function computeRoi(inputs: RoiInputs): RoiResult {
	const weeklyHours = inputs.people * inputs.hours;
	const annualHours = weeklyHours * 52;
	const weeklyCost = weeklyHours * inputs.rate;
	const annualCost = annualHours * inputs.rate;
	return { ...inputs, weeklyHours, annualHours, weeklyCost, annualCost };
}

export function equivalentLine(result: RoiResult): string {
	const workdays = Math.round(result.annualHours / 8);
	const fteShare = Math.round((result.annualHours / 2080) * 100);
	if (fteShare >= 15) {
		return `That is roughly ${workdays} work days a year, or about ${fteShare}% of a full-time role spent on tasks a system could likely do.`;
	}
	return `That is roughly ${workdays} work days a year going to tasks a system could likely do instead.`;
}

export function buildRoiSummary(result: RoiResult, tasks: string[]): string {
	return [
		'AUTOMATION ROI ESTIMATE',
		'',
		`People doing this work: ${result.people}`,
		`Hours per week, per person: ${result.hours}`,
		`Fully loaded hourly cost: ${money(result.rate)}`,
		'',
		`Weekly cost: ${money(result.weeklyCost)}`,
		`Annual hours: ${Math.round(result.annualHours).toLocaleString('en-US')}`,
		`Annual cost: ${money(result.annualCost)}`,
		'',
		`Type of work: ${tasks.length ? tasks.join(', ') : 'not specified'}`,
		'',
		equivalentLine(result),
	].join('\n');
}

export function isValidEmail(value: string): boolean {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}
